import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { deviceEquals } from 'features/dashboard/operation/adGroupDeviceEdit/AdGroupDeviceEditModal'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  form: {
    deviceSettingType: 'ALL',
    deviceTypes: [],
  },
  preview: {
    deviceSettingType: 'ALL',
    deviceTypes: [],
  },
}

export const showAdGroupDeviceEdit = createAxiosThunk(
  'dashboard/showAdGroupDeviceEdit',
  adGroupIds => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupsDevice = createAxiosThunk(
  'dashboard/updateAdGroupsDevice',
  (noArgs, { getState }) => {
    const {
      adGroups,
      form: { deviceSettingType, deviceTypes },
    } = getState().dashboard.operation.adGroupDeviceEdit
    return api.ad.patchAdGroupsDevice({
      adGroupIds: adGroups.map(({ id }) => id),
      deviceSettingType,
      ...(deviceSettingType === 'SETTING' && { deviceTypes }),
    })
  }
)

const adGroupDeviceEditSlice = createSlice({
  name: 'dashboard/adGroupDeviceEdit',
  initialState,

  reducers: {
    hideAdGroupDeviceEdit: () => initialState,
    setDeviceSettingType: (state, { payload }) => {
      if (state.form.deviceSettingType === 'ALL' && payload === 'SETTING') {
        state.form.deviceTypes = ['MOBILE', 'PC']
      }
      state.form.deviceSettingType = payload
    },
    setDeviceTypes: (state, { payload: { checked, value } }) => {
      if (checked) {
        state.form.deviceTypes.push(value)
      } else {
        const index = state.form.deviceTypes.indexOf(value)
        if (index !== -1) state.form.deviceTypes.splice(index, 1)
      }
    },
    showPreview: state => {
      state.preview.deviceSettingType = state.form.deviceSettingType
      state.preview.deviceTypes = state.form.deviceTypes
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupDeviceEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(showAdGroupDeviceEdit.rejected, (state, { payload }) => {
      state.loadingError = payload
      state.isLoading = false
    })

    builder.addCase(
      showAdGroupDeviceEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(({ id, name, deviceSetting }) => ({
          id,
          name,
          deviceSetting: {
            type: deviceSetting.type,
            deviceTypes: deviceSetting.deviceTypes || [],
          },
        }))
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every((value, index, array) =>
            deviceEquals(value.deviceSetting, array[0].deviceSetting)
          )
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const {
            deviceSetting: { type, deviceTypes },
          } = first
          state.form.deviceSettingType = type
          state.form.deviceTypes = deviceTypes
        }
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupsDevice.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupsDevice.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupsDevice.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const {
  hideAdGroupDeviceEdit,
  showPreview,
  hidePreview,
  setDeviceSettingType,
  setDeviceTypes,
} = adGroupDeviceEditSlice.actions
export default adGroupDeviceEditSlice.reducer
